/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type PatientSummaryDtoContactTracing =
  (typeof PatientSummaryDtoContactTracing)[keyof typeof PatientSummaryDtoContactTracing];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientSummaryDtoContactTracing = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
